export default function SlideUp (boxH,item,timer){
	if (boxH >= 1) {
		var boxH = boxH - 5;
		item.style.height = boxH + "px";
		timer = setTimeout(function(){ return SlideUp(boxH,item,timer)}, 5);
	} else {
		clearTimeout(timer);
		item.style.height = 0;
		item.style.display = "none";
	}
}
